// extracted by mini-css-extract-plugin
export default {"screenSwitch":"ScreenSwitch_screenSwitch__+Bn1j","switch":"ScreenSwitch_switch__cuxbD"};